import { render, staticRenderFns } from "./FundTerms.vue?vue&type=template&id=bc3697c0&lang=pug&"
import script from "./FundTerms.vue?vue&type=script&lang=js&"
export * from "./FundTerms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports